import { updateGetters } from '@/store/extensions/update';

export default {
  ...updateGetters,
};



// WEBPACK FOOTER //
// ./src/store/modules/appMembership/getters.js